import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import loginBgImg from "@/Assets/DBO06466.JPG.jpeg";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}`);
      nav(u.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2">
      <div className="relative hidden lg:block">
        <img
          src={loginBgImg}
          alt="Wedding Atelier"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40" />
        <div className="absolute bottom-12 left-12 text-white max-w-md">
          <div className="overline mb-3 opacity-80">DobhaiOfficial · Portal Access</div>
          <h2 className="font-serif text-4xl leading-tight">Welcome back to Dobhai Official.</h2>
        </div>
      </div>
      <div className="flex items-center justify-center p-8 md:p-16">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="login-form">
          <Link to="/" className="font-serif text-3xl block mb-12 tracking-tight">Dobhai<span className="text-primary">Official</span></Link>
          <h1 className="font-serif text-4xl mb-3">Sign in</h1>
          <p className="text-sm text-muted-foreground mb-8">
            Don't have an account?{" "}
            <Link to="/register" className="text-primary underline" data-testid="to-register">Create one</Link>
          </p>
          <div className="space-y-5">
            <div>
              <label className="overline text-muted-foreground">Email</label>
              <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full border border-input bg-background px-4 py-3 mt-2 text-sm focus:outline-none focus:ring-1 focus:ring-ring"
                data-testid="login-email" />
            </div>
            <div>
              <label className="overline text-muted-foreground">Password</label>
              <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full border border-input bg-background px-4 py-3 mt-2 text-sm focus:outline-none focus:ring-1 focus:ring-ring"
                data-testid="login-password" />
            </div>
            <button type="submit" disabled={loading} className="btn-primary-filled w-full disabled:opacity-60" data-testid="login-submit">
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}s